/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import TreatmentRadiation from './treatment-radiation';
import TreatmentRadiationDetail from './treatment-radiation-detail';
import TreatmentRadiationUpdate from './treatment-radiation-update';
import TreatmentRadiationDeleteDialog from './treatment-radiation-delete-dialog';

const TreatmentRadiationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<TreatmentRadiation />} />
    <Route path="new" element={<TreatmentRadiationUpdate />} />
    <Route path=":id">
      <Route index element={<TreatmentRadiationDetail />} />
      <Route path="edit" element={<TreatmentRadiationUpdate />} />
      <Route path="delete" element={<TreatmentRadiationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default TreatmentRadiationRoutes;
